import React from 'react'
import DefaultSettingManagement from './abstract/DefaultSettingManagement'
import Window from '../../../../common/Window'
import Loading from '../../../../common/component/Loading'

class KodomoSetting extends DefaultSettingManagement {
  constructor (props) {
    super(props)
    this.state = {isLoaded: false}
    this.systemSettingName = 'KodomoSetting'
  }
  onInsert (offset) {
    offset = Number(offset)
    const kodomoRyouritsuList = this.getSettingData()
    kodomoRyouritsuList.splice(offset + 1, 0,
      {
        startMonth: this.getIntYM(),
        endMonth: this.getIntYM(),
        ryouritsu: null
      }
    )
    this.setState({
      KodomoSetting: kodomoRyouritsuList,
      KodomoSettingInputData: JSON.parse(JSON.stringify(kodomoRyouritsuList))
    })
  }
  onDelete (offset) {
    if (this.getSettingData().length > 1) {
      Window.confirm('この行を削除してもよろしいですか?', () => {
        offset = Number(offset)
        const kodomoRyouritsuList = this.getSettingData()
        kodomoRyouritsuList.splice(offset, 1)
        this.setState({
          KodomoSetting: kodomoRyouritsuList,
          KodomoSettingInputData: JSON.parse(JSON.stringify(kodomoRyouritsuList))
        })
        Window.closeDialog()
      })
    }
  }
  onMoveUp (offset) {
    offset = Number(offset)
    if (offset > 0) {
      const kodomoRyouritsuList = this.getSettingData()
      kodomoRyouritsuList.splice(offset - 1, 2, kodomoRyouritsuList[offset], kodomoRyouritsuList[offset - 1])
      this.setState({
        KodomoSetting: kodomoRyouritsuList,
        KodomoSettingInputData: JSON.parse(JSON.stringify(kodomoRyouritsuList))
      })
    }
  }
  onMoveDown (offset) {
    offset = Number(offset)
    const kodomoRyouritsuList = this.getSettingData()
    if (offset < kodomoRyouritsuList.length - 1) {
      offset++
      kodomoRyouritsuList.splice(offset - 1, 2, kodomoRyouritsuList[offset], kodomoRyouritsuList[offset - 1])
      this.setState({
        KoyouSetting: kodomoRyouritsuList,
        KodomoSettingInputData: JSON.parse(JSON.stringify(kodomoRyouritsuList))
      })
    }
  }
  getEditor (index, attributeName) {
    const value = this.state.KodomoSettingInputData[index][attributeName] ? this.state.KodomoSettingInputData[index][attributeName] : ''
    return (
      <input type='text' name={attributeName} value={value} onChange={(e) => this.changeKodomoData(index, attributeName, e)} />
    )
  }
  changed (index, attributeName, e) {
    const KodomoSetting = this.state.KodomoSetting
    KodomoSetting[index][attributeName] = parseInt(e.target.value)
    this.setState({
      KodomoSetting: KodomoSetting,
      KodomoSettingInputData: JSON.parse(JSON.stringify(KodomoSetting))
    })
  }
  changeKodomoData (index, attributeName, e) {
    const KodomoSetting = this.state.KodomoSetting
    const KodomoSettingInputData = this.state.KodomoSettingInputData
    let changedValue = e.target.value

    // 数値と少点数以外を除く
    changedValue = changedValue.replace(/[^0-9.]/g, '')
    // input用データ
    KodomoSettingInputData[index][attributeName] = changedValue
    // 保存用データ（小数を含む整数にする）
    KodomoSetting[index][attributeName] = parseFloat(changedValue)
    this.setState({
      KodomoSetting: KodomoSetting,
      KodomoSettingInputData: KodomoSettingInputData
    })
  }
  render () {
    if (!this.state.isLoaded) {
      return <Loading />
    }
    const kodomoRyouritsuList = this.getSettingData()
    const yearMonthList = this.getYMList(6, 201509).reverse()
    const yearMonthListToShow = []
    yearMonthList.forEach(ym => {
      yearMonthListToShow.push(
        <option key={this.uuid()} value={ym.id}>{ym.name}</option>
      )
    })
    const kodomoRyouritsuListToShow =
    kodomoRyouritsuList.map((kodomoRyouritsu, index, list) => {
      const isTop = (index === 0)
      const isBottom = (index === list.length - 1)
      const isOnlyOne = (list.length <= 1)
      return (
        <tr key={index}>
          <th className='kw-ds-no'>{index + 1}</th>
          <td><select value={kodomoRyouritsu.startMonth} onChange={(e) => this.changed(index, 'startMonth', e)} >{yearMonthListToShow}</select></td>
          <td><select value={kodomoRyouritsu.endMonth} onChange={(e) => this.changed(index, 'endMonth', e)} >{yearMonthListToShow}</select></td>
          <td>{this.getEditor(index, 'ryouritsu')}</td>
          <td className='kw-ds-gyou-sousa-icons'>
            <span className='text-success'><i className='icon-plus-sign kw-pointer' onClick={this.onInsert.bind(this, index)} /></span>
            <span className='text-error'><i className='icon-minus-sign' onClick={this.onDelete.bind(this, index)}
              style={isOnlyOne ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(185, 74, 72)', cursor: 'pointer'}} /></span>
            <span className='text-info'><i className='icon-circle-arrow-up' style={isTop ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(58, 135, 173)', cursor: 'pointer'}}
              onClick={this.onMoveUp.bind(this, index)} /></span>
            <span className='text-info'><i className='icon-circle-arrow-down' style={isBottom ? {color: 'gray', cursor: 'not-allowed'} : {color: 'rgb(58, 135, 173)', cursor: 'pointer'}}
              onClick={this.onMoveDown.bind(this, index)} /></span>
          </td>
        </tr>
      )
    })
    return (
      <form id='userSecurityForm' className='form-horizontal' method='post' onSubmit={this.onSubmit.bind(this)}>
        <div className='row'>
          <fieldset className='kw-ds-regist-area span16'>
            <legend>子ども・子育て拠出金</legend>
            <div className='alert alert-block alert-info'>
              <p>
                必要な情報を入力して最後に「登録」ボタンを押してください。
              </p>
            </div>
            <table>
              <thead>
                <tr>
                  <th className='kw-ds-no' />
                  <th className='kw-ds-start-month' />
                  <th className='kw-ds-end-month' />
                  <th className='kw-ds-ryouritsu' />
                  <th className='kw-ds-gyou-sousa' />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th className='kw-ds-no'>No.</th>
                  <th>適用開始年月</th>
                  <th>適用終了年月</th>
                  <th>料率</th>
                  <th className='kw-ds-gyou-sousa'>行操作</th>
                </tr>
                {kodomoRyouritsuListToShow}
              </tbody>
            </table>
            <footer id='submit-actions' className='form-actions'>
              <button id='submit-button' type='submit' className='btn btn-primary' name='action' value='CONFIRM'>登録</button>
            </footer>
          </fieldset>
        </div>
      </form>
    )
  }
}
export default KodomoSetting



// WEBPACK FOOTER //
// ./src/admin/pages/secure/DefaultSetting/KodomoSetting.js